import React, {useEffect} from "react";
import leftPng from "../../../../../content/images/left.png";
import $ from "jquery";

const Detail = () => {
    useEffect(() => {
        $("#organization-detail-button").click(function () {
            const detailSide = $("#detailSide")
            if (detailSide.attr("name") === "dbl") {
                $("#tableSide").addClass("d-none");
                detailSide.removeAttr("name");
                detailSide.removeClass("d-none");
                $("#editSide").addClass("d-none");
                $("#organisatie-detail").addClass("d-none");
            } else {
                $("#tableSide").removeClass("d-none");
                detailSide.addClass("d-none");
                $("#editSide").addClass("d-none");
                $("#organisatie-detail").addClass("d-none");
            }
        });
    });

    // function openEditPage() {
    //
    // }

    return (
        <div id="organisatie-detail" className="d-none">
            <div className="detail-title">Organisatie in detail</div>
            <div className="clearfix">
                <div className="float-left mt-4">
                    <a
                        id="organization-detail-button"
                        className="back-page-link"
                        role="button"
                    >
                        <img src={leftPng} width={9} height={12}/>
                        <div id={"back-page-link-inner-text"} style={{float: "right"}}>&nbsp;Terug naar Detail</div>
                    </a>
                </div>
                <div className="float-right mt-0">
                    <a id="organization-edit-button" className="button bewerken d-none">
                        Bewerken
                    </a>
                </div>
            </div>
            <div className="row clearfix">
                <div className="col-lg-4 text-center">
                    <div className="box-detail-active">
                        <div className="box-title-1-active">Naam organisatie</div>
                        <div className="box-title-2-active" id="organisatie-naam"/>
                        <span
                            className="tooltiptext detail"
                            id="organisatie-naam-tooltip"
                        />
                    </div>
                </div>
                <div className="col-lg-4 text-center">
                    <div className="box-detail">
                        <div className="box-title-1">e-mail</div>
                        <div className="box-title-2" id="organisatie-email"/>
                    </div>
                </div>
                <div className="col-lg-4 text-center">
                    <div className="box-detail">
                        <div className="box-title-1">Website</div>
                        <div className="box-title-2" id="organisatie-website"/>
                    </div>
                </div>
            </div>
            <div className="row clearfix">
                <div className="col-lg-4 text-center">
                    <div className="box-detail">
                        <div className="box-title-1">Straat</div>
                        <div className="box-title-2" id="organisatie-straat"/>
                    </div>
                </div>
                <div className="col-lg-4 text-center">
                    <div className="box-detail">
                        <div className="box-title-1">Nummer</div>
                        <div className="box-title-2" id="organisatie-nummer"/>
                    </div>
                </div>
                <div className="col-lg-4 text-center">
                    <div className="box-detail">
                        <div className="box-title-1">Postcode</div>
                        <div className="box-title-2" id="organisatie-postcode"/>
                    </div>
                </div>
            </div>

            <div className="row clearfix">
                <div className="col-lg-4 text-center">
                    <div className="box-detail">
                        <div className="box-title-1">Woonplaats</div>
                        <div className="box-title-2" id="organisatie-woonplaats"/>
                    </div>
                </div>
                <div className="col-lg-4 text-center">
                    <div className="box-detail">
                        <div className="box-title-1">Opmerking</div>
                        <div className="box-title-2" id="organisatie-opmerking"/>
                    </div>
                </div>
                <div className="d-none col-lg-4 text-center" id="timestamp_created_div">
                    <div className="box-detail">
                        <div className="box-title-1">Datum aangemaakt</div>
                        <div className="box-title-2" id="timestamp_created"/>
                    </div>
                </div>
            </div>

            <div className="row clearfix">
                <div className="col-lg-4 text-center">
                    <div className="box-detail">
                        <div className="box-title-1">Actief</div>
                        <label className="switch">
                            <input id="organisatie-active" type="checkbox" disabled/>
                            <span className="slider-checkbox round"/>
                        </label>
                    </div>
                </div>
                <div className="col-lg-4 text-center">
                    <div className="box-detail">
                        <div className="box-title-1">Is uitvoerder</div>
                        <label className="switch">
                            <input id="organisatie-uitvoerder" type="checkbox" disabled/>
                            <span className="slider-checkbox round"/>
                        </label>
                    </div>
                </div>
                <div className="col-lg-4 text-center d-none" id="timestamp_updated_div">
                    <div className="box-detail">
                        <div className="box-title-1">Datum laatst gewijzigd</div>
                        <div className="box-title-2" id="timestamp_updated"/>
                    </div>
                </div>
            </div>

            <div className="row clearfix" id="relations-row">

            </div>

        </div>
    );
};

export default Detail;
